<template>
  <div>
    <crud-template
        :editedItem.sync="formData"
        @deleteItem="deleteItem"
        @dialogClosed="clearForm" ref="formTemplate">
      <template #default="{editItemHandler}">
        <div class="text-right mb-3">
          <btn-with-tooltip @click="editItemHandler('create')" class-name="action-btn" color="primary">
            <v-icon small>fas fa-plus</v-icon>
            <template #tooltip>Создать</template>
          </btn-with-tooltip>
        </div>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            hide-default-footer>
          <template #item.is_default="{item}">
            {{ item.is_default ? 'Да' : 'Нет' }}
          </template>
          <template #item.action="{item}">
            <div class="action-btn-wrap">
              <v-btn @click="editItemHandler('edit', item)" class="action-btn" color="warning">
                <v-icon x-small>fas fa-pencil-alt</v-icon>
              </v-btn>
              <v-btn @click="editItemHandler('delete', item)" class="action-btn" color="error">
                <v-icon x-small>fas fa-trash</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <v-pagination
            v-if="options.last_page > 1"
            v-model="options.current_page"
            :length="options.last_page"
        ></v-pagination>
      </template>
      <template #form-content="{loading, isUpdate}">
        <validation-observer ref="formObs" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit(() => {save(isUpdate)})">
            <custom-input-text
                label="Цена"
                name="Цена"
                rules="required"
                type="numeric"
                v-model="formData.price"
                vid="price"
            ></custom-input-text>
            <custom-autocomplete
                item-value="value"
                :items="types"
                clearable
                label="Тип"
                v-model="formData.type"
            ></custom-autocomplete>
            <v-btn :loading="loading" color="primary" type="submit" width="100%">Сохранить</v-btn>
          </form>
        </validation-observer>
      </template>
    </crud-template>
  </div>
</template>

<script>
import CrudTemplate from '@/components/ui/crud/template'
import {messages} from '@/utils/constants'

export default {
  name: "index",
  data() {
    return {
      items: [],
      headers: [
        {
          text: 'Цена',
          value: 'price'
        },
        {
          text: 'Тип',
          value: 'type'
        },
        {
          text: 'Действие',
          value: 'action'
        }
      ],
      formData: {
        price: null,
        type: null,
      },
      types: [],
      options: {
        last_page: 1,
        current_page: 1
      }
    }
  },
  methods: {
    clearForm() {
      const {formObs} = this.$refs
      if (formObs) formObs.reset()
    },
    async getItems() {
      let params = {
        page: this.options.current_page
      }
      try {
        const {data: {data, links: {last_page}}} = await this.$http.get('admin/price', {params})
        this.items = data
        this.options.last_page = last_page
      } catch (e) {
        this.$setResponseError({error: e})
      }

    },
    async save(isUpdate) {
      const {formTemplate} = this.$refs
      formTemplate.$showFormLoading()
      if (isUpdate) {
        await this.update()
      } else {
        await this.create()
      }
      formTemplate.$clearFormLoading()
    },
    async deleteItem(item) {
      this.$showLoading()
      try {
        await this.$http.delete(`admin/price/${item.id}`)
        this.$setSuccess({text: messages.onDelete})
        await this.getItems()
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async update() {
      try {
        const {formTemplate} = this.$refs
        const {id} = this.formData
        await this.$http.put(`admin/price/${id}`, this.formData)
        await this.getItems()
        formTemplate.closeFormDialog()
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      }
    },
    async create() {
      try {
        const {formTemplate} = this.$refs
        await this.$http.post('admin/price', this.formData)
        await this.getItems()
        formTemplate.closeFormDialog()
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      }
    },
    async getTypes() {
      try {
        const {data: {data}} = await this.$http.get('admin/price/types')
        this.types = data
      } catch (e) {
        this.$setResponseError({error: e})
      }
    }
  },
  components: {CrudTemplate},
  async created() {
    this.$showLoading()
    await this.getItems()
    this.$clearLoading()
    await this.getTypes();
  },
  watch: {
    "options.current_page": "getItems"
  }
}
</script>

<style scoped>

</style>
